module.exports = __webpack_public_path__ + "img/coupon_tutorial_romakyun02.678a34d4.png";